export const UPLOAD_RETRY_LIMIT = 5;

export enum UPLOAD_AGENT_EVENTS {
    RUN_QUEUE = "RUN_QUEUE",
    UPLOAD = "UPLOAD",
    INSTANCE_ID = "INSTANCE_ID",
    LOCATION = "LOCATION",
}

export enum UPLOAD_WORKER_EVENTS {
    UPLOAD_OFFLINE = "UPLOAD_OFFLINE",
    UPLOAD_ONLINE = "UPLOAD_ONLINE",
    UPLOAD_UNAUTHENTICATED = "UPLOAD_UNAUTHENTICATED",
    UPLOAD_FAILED = "UPLOAD_FAILED",
    REQUEST_LOCATION = "REQUEST_LOCATION",
}

export enum UPLOAD_TYPES {
    SALE = "sale",
    UPDATE_SALE = "update-sale",
    BARCODE = "barcode",
    OPEN_REGISTER = "open-register",
    CUSTOMER = "customer",
    UPDATE_CUSTOMER = "update-customer",
    EMAIL_RECEIPT = "email-receipt",
    ACTION = "action",
    TAKINGS = "takings",
    VOID_SALE = "void-sale",
    UNPARK_SALE = "unpark-sale",
    CUSTOMER_PAYMENT = "customer-payment",
    EMAIL_COMPONENT = "email-component",
    CLOSE_REGISTER = "close-register",
    STOCKTAKE_COUNT = "stocktake-count",
    ERROR = "error",
    SECURITY_EVENT = "security-event",
    KITCHEN_ORDER = "kitchen-order",
}
